export const ADD_BOOKMARK = 'ADD_BOOKMARK'
export const ADD_BOOKMARKS = 'ADD_BOOKMARKS'
export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE'
export const CLICK_CONTEXT_BAR_ITEM = 'CLICK_CONTEXT_BAR_ITEM'
export const CLOSE_CONTEXT_BAR_ITEMS = 'CLOSE_CONTEXT_BAR_ITEMS'
export const CHANGE_BASELAYER = 'CHANGE_BASELAYER'
export const CHANGE_INPUT = 'CHANGE_INPUT'
export const CLEAR_FRAMEWORK = 'CLEAR_FRAMEWORK'
export const EXTENT_HANDLED = 'EXTENT_HANDLED'
export const FETCH_ERROR = 'FETCH_ERROR'
export const MOVE_BOOKMARK = 'MOVE_BOOKMARK'
export const OPEN_CONTEXT_BAR_ITEMS = 'OPEN_CONTEXT_BAR_ITEMS'
export const PATCH_STATE = 'PATCH_STATE'
export const RECEIVE_FRAMEWORKS = 'RECEIVE_FRAMEWORKS'
export const RECEIVE_FICUS_DATA = 'RECEIVE_FICUS_DATA'
export const RECEIVE_FICUS_FRAMEWORK_INFO = 'RECEIVE_FICUS_FRAMEWORK_INFO'
export const RECEIVE_STATE = 'RECEIVE_STATE'
export const RECEIVE_STATE_ERROR = 'RECEIVE_STATE_ERROR'
export const REFUGEE_MODEL_DISPLAY_STATISTICS = 'REFUGEE_MODEL_DISPLAY_STATISTICS'
export const REFUGEE_MODEL_WINDOW_STATE = 'REFUGEE_MODEL_WINDOW_STATE'
export const REMOVE_BOOKMARK = 'REMOVE_BOOKMARK'
export const REMOVE_MAP_LOCATION = 'REMOVE_MAP_LOCATION'
export const REMOVE_MAP_LOCATIONS = 'REMOVE_MAP_LOCATIONS'
export const RESET_ANALYSIS_DATA = 'RESET_ANALYSIS_DATA'
export const SET_ANALYZE_MODE = 'SET_ANALYZE_MODE'
export const SET_ANALYSIS_DATA = 'SET_ANALYSIS_DATA'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const SET_FETCHED_STATE = 'STATE/SET_FETCHED'
export const SET_FETCHING_STATE = 'SET_FETCHING_STATE'
export const SET_FETCHING_FICUS_DATA = 'SET_FETCHING_FICUS_DATA'
export const SET_FETCHING_FRAMEWORKS = 'SET_FETCHING_FRAMEWORKS'
export const SET_FETCHING_FRAMEWORK_INFO = 'SET_FETCHING_FRAMEWORK_INFO'
export const SET_FICUS_CONFIG = 'SET_FICUS_CONFIG'
export const SET_FICUS_FRAMEWORK_INFO_URL = 'SET_FICUS_FRAMEWORK_URL'
export const SET_HEADER_VISIBLITY = 'SET_HEADER_VISIBILITY'
export const UPDATE_MAPSOURCE_LAYER = 'UPDATE_MAPSOURCE_LAYER'
export const UPDATE_REFUGEE_GRID = 'UPDATE_REFUGEE_GRID'
export const SET_POINT_DATA = 'SET_POINT_DATA'
export const TOGGLE_ANALYSIS_PANEL_VISIBLE = 'TOGGLE_ANALYSIS_PANEL_VISIBLE'
export const TRANSIMS_RUNNING = 'TRANSIMS_RUNNING'
export const TRANSIMS_WINDOW_STATE = 'TRANSIMS_WINDOW_STATE'
export const TRANSIMS_ZONE_COLOR = 'TRANSIMS_ZONE_COLOR'
export const UPDATE_MAP_LOCATION = 'UPDATE_MAP_LOCATION'
export const UPDATE_META = 'UPDATE_META'
export const UPDATE_COLLABORATION_SETTINGS = 'UPDATE_COLLABORATION_SETTINGS'
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'
export const VALIDATION_ERROR = 'VALIDATION_ERROR'

// Collaboration actions
export const FETCH_JOIN_SESSION = 'SESSIONS/FETCH_JOIN'
export const FETCH_LEAVE_SESSION = 'SESSIONS/FETCH_LEAVE'
export const FETCH_SHARE_SESSION = 'SESSIONS/SHARE'
export const FETCH_SESSIONS = 'SESSIONS/GET'
export const FETCH_SESSION_STATE = 'SESSIONS/GET_STATE'
export const FETCH_UNSHARE_SESSION = 'SESSIONS/UNSHARE'
export const HANDLED_CLICK_MAP = 'HANDLED/CLICK_MAP'
export const HANDLED_CLICK_REALIZATIONS = 'HANDLED/CLICK_REALIZATIONS'
export const HANDLED_CLOSE_POPUP = 'HANDLED/CLOSE_POPUP'
export const HANDLED_SET_ANALYZE_MODE = 'HANDLED/SET_ANALYZE_MODE'
export const HANDLED_SET_FICUS_CONFIG = 'HANDLED/SET_SET_FICUS_CONFIG'
export const HANDLED_SET_FRAMEWORK = 'HANDLED/SET_FRAMEWORK'
export const RECEIVE_JOIN_SESSION = 'SESSIONS/RECEIVE_JOIN'
export const RECEIVE_LEAVE_SESSION = 'SESSIONS/RECEIVE_LEAVE'
export const RECEIVE_SESSIONS = 'SESSIONS/RECEIVE'
export const RECEIVE_SESSION_STATE = 'SESSIONS/RECEIVE_STATE'
export const RECEIVE_SHARE_SESSION = 'SESSIONS/RECEIVE_SHARE_SESSION'
export const RECEIVE_UNSHARE_SESSION = 'SESSIONS/RECEIVE_UNSHARE_SESSION'

// Operational Transform actions
export const OT_UPDATE_MAP_VIEW = 'TRANSFORMS/UPDATE_MAP_VIEW'
export const OT_CLICK_MAP = 'TRANSFORMS/CLICK_MAP'
export const OT_CLICK_REALIZATIONS = 'TRANSFORMS/CLICK_REALIZATIONS'
export const OT_CLOSE_POPUP = 'TRANSFORMS/CLOSE_POPUP'
export const OT_SET_ANALYZE_MODE = 'TRANSFORMS/SET_ANALYZE_MODE'
export const OT_SET_FICUS_CONFIG = 'TRANSFORMS/SET_FICUS_CONFIG'
export const OT_SET_FRAMEWORK = 'TRANSFORMS/SET_FRAMEWORK'
export const OT_SHARE_SESSION = 'TRANSFORMS/SHARE_SESSION'
export const OT_UNSHARE_SESSION = 'TRANSFORMS/UNSHARE_SESSION'
export const OT_READONLY = 'TRANSFORMS/READONLY'
